export { default } from './IconValuePair'
